// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3h1WQ","col":"styles_col__1MLCS"};